export const aeroplaneLoaderState = {
  showAeroplane: false,
};
